module.exports = "/_next/static/images/StockScreenerBanner-d659bd84a775fc4fad65a75b9b5947b9.svg";